import Table, { TableCell } from "../../components/Table";
import Icon from "../../components/Icon";

import styles from "./Shortcuts.module.css";
import SectionTitle from "../../components/SectionTitle";
import React from "react";

const Shortcuts = () => (
  <div className={styles.wrapper}>
    <SectionTitle>Shortcuts</SectionTitle>

    <Table>
      <tbody>
        <tr>
          <TableCell type="key" className={styles.keyCell}>
            <Icon name="keyboard_arrow_left" className={styles.keyIcon} />
          </TableCell>
          <TableCell type="value">Previous column</TableCell>
        </tr>
        <tr>
          <TableCell type="key" className={styles.keyCell}>
            <Icon name="keyboard_arrow_right" className={styles.keyIcon} />
          </TableCell>
          <TableCell type="value">Next column</TableCell>
        </tr>
        <tr>
          <TableCell type="key" className={styles.keyCell}>
            <Icon name="keyboard_arrow_up" className={styles.keyIcon} />
          </TableCell>
          <TableCell type="value">Previous method</TableCell>
        </tr>
        <tr>
          <TableCell type="key" className={styles.keyCell}>
            <Icon name="keyboard_arrow_down" className={styles.keyIcon} />
          </TableCell>
          <TableCell type="value">Next method</TableCell>
        </tr>
      </tbody>
    </Table>
  </div>
);

export default Shortcuts;
